import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
import { Item } from "../items/item.entity";
import { PackingMethod } from "../packing-mathods/packing-methods.entity";

@Entity('uoms')
export class Uoms {

  @PrimaryGeneratedColumn("increment",{name:'uom_id'})
  uomId:number;
  
  @Column("varchar",{
      nullable:false,
      length:20,
      name:"uom_name"
      })    
    // @Index({unique:true})
    uomName:string;
    @Column("varchar",{
        nullable:false,
        length:20,
        name:"uom_type"
        })
    uomType:string;

  @Column("boolean",{
    nullable:false,
    default:true,
    name:"is_active"
    })
  isActive:boolean;

  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: false,
    name: "created_user",
    length: 50
  })
  createdUser: string;
  


  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user",
    length:50
})
updatedUser: string | null;

  @VersionColumn({
      default:1,
      name: "version_flag"
  })
  versionFlag: number;

  @OneToMany(type=>Item, item=>item.uomInfo)
  itemInfo:Item[];

  @OneToMany(type=>PackingMethod, pm=>pm.uomInfo)
  pmInfo:PackingMethod[];

  @OneToMany(type=>Item, item=>item.itemUom)
  itemUomInfo:Item[];
}
